import React, { useEffect, useState } from "react";
import ContentHeading from "../../../../components/layout/content/ContentHeading";
import InputTextField from "../../../../components/input/inputTextField";
import TableCustom from "../../../../components/table/tableCustom";
import TableRowCommon from "../../../../components/table/TableRowCommon";
import { useDispatch } from "react-redux";
import { NavigateFunction, useNavigate } from "react-router-dom";
import { SearchOutlined } from "@mui/icons-material";
import { debouncedApiCall } from "../../../../utils/app.utils";
import { CourseAnnualDetailAPI } from "../../../../api/course-annual-detail/course-annual-detail.api";
import { dateToView } from "../../../../utils/date.utils";
import { icons } from "../../../../assets/icons/icons";
import {
  alertActive,
  alertError,
  alertSuccess,
} from "../../../../components/alert/swal";
import {
  setLoading,
  unsetLoading,
} from "../../../../store/loading/loading.slice";
import ModalCustom from "../../../../components/modal/ModalCustom";
import { EquipmentApi } from "../../../../api/equipment/equipment.api";
import {
  ButtonOutlined,
  ButtonPrimary,
} from "../../../../components/button/ButtonCustoms";
import { Button, useMediaQuery, useTheme } from "@mui/material";
import { RoomMeetingManagementApi } from "../../../../api/room-meeting-management/room-meeting-management.api";
import InputTextMask from "../../../../components/input/inputTextMask";

interface RoomMeetingDeviceProps {
  dataDevice: any[];
  onGetData: () => void;
  id_room_meeting?: number;
}

const RoomMeetingDevice: React.FC<RoomMeetingDeviceProps> = ({
  dataDevice,
  onGetData,
  id_room_meeting = 0,
}) => {
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.up('md'));
  const dispatch = useDispatch();

  const [search, setSearch] = useState<string>("");
  const [data, setData] = useState<any[]>([]);
  const [mode, setMode] = useState<string>("VIEW");

  const [page, setPage] = useState<number>(1);
  const [pageLimit, setPageLimit] = useState<number>(10);
  const [totalItems, setTotalItems] = useState<number>(0);
  const [sortBy, setSortBy] = useState<string>("");
  const [sortType, setSortType] = useState<string>("ASC");

  const [idRoomMeetingEquipment, setIdRoomMeetingEquipment] = useState<number>(0)
  const [isModalForm, setisModalForm] = useState<boolean>(false);
  const [inputValue, setInputValue] = useState<any>({
    id: "",
    name: "",
    no: "",
    qty: "",
    unit: "",
    image: "",
  });

  const handleRequestSort = (sortBy: string, sortType: string) => {
    setSortBy(sortBy);
    setSortType(sortType);
  };

  const getData = async (search: string, qty?: number) => {
    let query: any = {
      page: 1,
      limit: 100000,
      sortBy: sortBy,
      sortType: sortType,
      keyword: search ?? "",
    };

    const res = await EquipmentApi.getAllEquipment(query);
    const data = res.data;
    if (data.status < 300) {
      const formattedData =
        res.data?.data?.items?.map((item: any) => ({
          id_device: item.id_equipment || "",
        })) ?? [];
      setData(formattedData);

      if (formattedData.length > 0) {
        const id_device = formattedData[0].id_device;
        if (id_device) {
          const res = await EquipmentApi.getEquipmentById(id_device);
          const data = res.data;

          if (data.status < 300) {
            const pathFile =
              process.env.REACT_APP_FILE_BASE_API +
              "/" +
              data.data?.lastFile.file_path;
            setInputValue({
              id: data.data?.equipment?.id_equipment,
              no: data.data?.equipment?.equipment_no,
              name: data.data?.equipment?.equipment_name,
              qty: qty ?? 0,
              unit: data.data?.equipment?.equipment_unit,
              image: pathFile,
            });
          }
        }
      }
    } else {
      setData([]);
    }
  };

  const handleDelete = async (id_room_meeting_equipment: number) => {
    if (id_room_meeting_equipment) {
      alertActive(
        "ลบอุปกรณ์",
        "ท่านต้องการลบอุปกรณ์ ใช่หรือไม่",
        undefined,
        undefined,
        async () => {
          dispatch(setLoading());
          await RoomMeetingManagementApi.deleteEquipmentToRoomMeeting(
            +id_room_meeting_equipment
          )
            .then((res) => {
              if (res.status < 300) {
                alertSuccess(
                  "ลบอุปกรณ์ เรียบร้อย",
                  undefined,
                  undefined,
                  () => {
                    onGetData();
                  }
                );
              }
            })
            .catch(() => {
              alertError("ลบอุปกรณ์ ไม่สำเร็จ");
            })
            .finally(() => {
              dispatch(unsetLoading());
            });
        }
      );
    }
    return;
  };

  const headCells = [
    {
      id: "no",
      width: 50,
      sortable: false,
      disablePadding: false,
      align: "center",
      label: "ลำดับ",
    },
    {
      id: "period",
      width: 100,
      sortable: false,
      disablePadding: false,
      align: "start",
      label: "รหัสอุปกรณ์",
    },
    {
      id: "period",
      width: 150,
      sortable: false,
      disablePadding: false,
      align: "start",
      label: "ชื่ออุปกรณ์",
    },
    {
      id: "จำนวน",
      width: 150,
      sortable: false,
      disablePadding: false,
      align: "start",
      label: "จำนวน",
    },
    {
      id: "action",
      width: 75,
      sortable: false,
      disablePadding: false,
      align: "start",
      class: matches && dataDevice?.length == 0,
      label: "",
    },
  ];

  const renderData = (objData: any, no: any) => {
    no = page * pageLimit - pageLimit + no + 1;
    const { id_room_meeting_equipment, equipment_no, equipment_name, qty } =
      objData;

    const objRenderData = {
      key: id_room_meeting_equipment,
      id: no,
      obj: objData,
      columns: [
        {
          option: "TEXT",
          align: "center",
          label: no ?? "-",
        },
        {
          option: "TEXT",
          align: "start",
          label: equipment_no ?? "-",
        },
        {
          option: "TEXT",
          align: "start",
          label: equipment_name ?? "-",
        },
        {
          option: "TEXT",
          align: "start",
          label: qty ?? "-",
        },
        {
          option: "COMPONENT",
          align: "center",
          class: matches,
          component: (
            <div
              style={{
                display: "flex",
                textAlign: "center",
                justifyContent: "center",
              }}
            >
              <img
                onClick={() => {
                  setMode("VIEW");
                  setisModalForm(true);
                  getData(equipment_no, qty);
                }}
                src={icons.eye}
                alt="eye"
                style={{ cursor: "pointer" }}
              />
              <img
                onClick={() => {
                  setMode("UPDATE");
                  setisModalForm(true);
                  getData(equipment_no, qty);
                  setIdRoomMeetingEquipment(id_room_meeting_equipment)
                }}
                src={icons.edit}
                alt="edit"
                style={{ cursor: "pointer", margin: "0px 12px" }}
              />
              <img
                src={icons.bag_cross}
                alt="bag_cross"
                style={{ cursor: "pointer" }}
                onClick={() => {
                  handleDelete(id_room_meeting_equipment);
                  setMode("DELETE");
                }}
              />
            </div>
          ),
        },
      ],
    };
    return <TableRowCommon {...objRenderData} />;
  };

  const handleCloseModal = () => {
    setisModalForm(false);
    setInputValue({
      id: "",
      name: "",
      no: "",
      qty: "",
      unit: "",
      image: "",
    });
  };

  const handleChange = (name: string, value: string) => {
    setInputValue((prev: any) => ({ ...prev, [name]: value }));
  };

  const handleAddEquipment = async () => {
    const title = inputValue.id ? "แก้ไขข้อมูลอุปกรณ์ภายในห้อง" : "เพิ่มข้อมูลอุปกรณ์ภายในห้อง";

    dispatch(setLoading());

    const body = {
      id_equipment: inputValue.id,
      qty: inputValue.qty,
      status: "ACTIVE",
    };

    try {
      let response;

      if (id_room_meeting && mode === "CREATE") {
        response = await RoomMeetingManagementApi.addEquipmentToRoomMeeting(
          id_room_meeting,
          body
        );
      } else {
        response = await RoomMeetingManagementApi.updateEquipmentToRoomMeeting(
          idRoomMeetingEquipment,
          body
        );
      }

      if (response.status < 300) {
        alertSuccess(title, `${title} สำเร็จ`, undefined, () => {
          onGetData();
          handleCloseModal();
        });
      }
    } catch (err: any) {
      alertError(title, err?.response?.data?.message || `${title} ไม่สำเร็จ`);
    } finally {
      dispatch(unsetLoading());
    }
  };

  return (
    <div>
      <ModalCustom
        open={isModalForm}
        title={
          mode === "CREATE"
            ? "เพิ่มข้อมูลอุปกรณ์ภายในห้อง"
            : mode === "UPDATE"
              ? "แก้ไขข้อมูลอุปกรณ์ภายในห้อง"
              : "ข้อมูลอุปกรณ์ภายในห้อง"
        }
        subTitle={"กรุณาเลือกรายการที่ท่านต้องการ"}

        onClose={handleCloseModal}
        component={
          <>
            <div className="w-full grid grid-cols-12 gap-6 mt-10">
              {/* Input for Service Name */}
              <div className="col-span-12 lg:col-span-8">
                <InputTextField
                  value={search}
                  required
                  placeholder="ค้นหา รหัส หรือ ชื่ออุปกรณ์"
                  onchange={(e: React.ChangeEvent<HTMLInputElement>) =>
                    setSearch(e.target.value)
                  }
                />
              </div>

              {/* Search and Clear Buttons */}
              <div className="col-span-12 lg:col-span-4 w-full flex justify-center gap-4 items-center">
                <span>
                  <ButtonPrimary
                    mode="done"
                    buttonName={"ค้นหา"}
                    disabled={!search}
                    onClick={() => {
                      getData(search);
                    }}
                  />
                </span>
                <span>
                  <ButtonOutlined
                    onClick={() => {
                      setInputValue({
                        id: "",
                        name: "",
                        no: "",
                        qty: "",
                        unit: "",
                        image: "",
                      });
                      setSearch("");
                    }}
                    disabled={!search}
                    mode="del"
                    buttonName="ล้างค่า"
                  />
                </span>
              </div>
            </div>

            <div className="w-full grid grid-cols-1 lg:grid-cols-2 gap-6 mt-10">
              {/* Image Section */}
              <article className="flex justify-center items-center">
                <div className="relative w-full flex justify-center group">
                  <div className="w-full h-48 overflow-hidden">
                    {inputValue.image && (
                      <img
                        src={inputValue.image}
                        alt="Uploaded"
                        className="w-full h-full object-contain"
                      />
                    )}
                  </div>
                </div>
              </article>

              {/* Input Section */}
              <article className="space-y-4">
                <InputTextField
                  value={inputValue.no}
                  heading="รหัสอุปกรณ์"
                  placeholder="รหัสอุปกรณ์"
                  disabled
                />

                <InputTextField
                  value={inputValue.name}
                  heading="ชื่ออุปกรณ์"
                  placeholder="ชื่ออุปกรณ์"
                  disabled
                />

                <div className="flex items-center space-x-4">
                  <InputTextMask
                    mode="full_number"
                    value={String(inputValue?.qty || "")}
                    heading="จำนวน"
                    placeholder="จำนวน"
                    disabled={!inputValue.id}
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                      handleChange("qty", e.target.value)
                    }
                  />

                  <Button
                    variant="outlined"
                    color="error"
                    sx={{ mt: 2 }}
                    onClick={() => {
                      setInputValue({
                        ...inputValue,
                        qty: Number(inputValue.qty || "") - 1,
                      });
                    }}
                    disabled={
                      Number(inputValue.qty || "") <= 1 || !inputValue.id || mode === "VIEW"
                    }
                  >
                    -
                  </Button>

                  <Button
                    variant="outlined"
                    color="success"
                    sx={{ mt: 2 }}
                    disabled={!inputValue.id || mode === "VIEW"}
                    onClick={() => {
                      setInputValue({
                        ...inputValue,
                        qty: Number(inputValue.qty || "") + 1,
                      });
                    }}
                  >
                    +
                  </Button>
                </div>

                <InputTextField
                  value={inputValue.unit}
                  heading="หน่วย"
                  required
                  placeholder="ระบุหน่วย"
                  disabled
                />
              </article>

              {/* Action Buttons */}
              <div className="mt-6 w-full flex justify-center gap-4 items-center col-span-2">
                <span>
                  <ButtonOutlined
                    onClick={handleCloseModal}
                    mode="del"
                    buttonName="ยกเลิก"
                  />
                </span>
                {mode !== "VIEW" && (
                  <span>
                    <ButtonPrimary
                      mode="done"
                      disabled={!inputValue.id || Number(inputValue.qty || "") < 1}
                      buttonName={mode === "UPDATE" ? "แก้ไข" : "ยืนยัน"}
                      onClick={() => {
                        handleAddEquipment();
                      }}
                    />
                  </span>
                )}
              </div>
            </div>
          </>
        }
      />

      <div className="w-full grid grid-cols-12 gap-4 mt-[40px]">
        <article className="w-full col-span-12 lg:col-span-12 md:col-span-9 sm:col-span-12 flex justify-end">
          <ButtonPrimary
            onClick={() => {
              setisModalForm(true);
              setMode("CREATE");
            }}
            mode="add"
            buttonName={"เพิ่มข้อมูลอุปกรณ์ภายในห้อง"}
          />
        </article>
      </div>

      <section className="w-full mt-10">
        <TableCustom
          tableMinWidth={1440}
          tableFixedWidth
          customScroll
          page={page}
          pageLimit={pageLimit}
          sortBy={sortBy}
          sortType={sortType}
          headCells={headCells}
          rowCount={totalItems}
          rowsData={
            dataDevice &&
            dataDevice.map((data: any, i: any) => {
              return renderData(data, i);
            })
          }
          onSort={handleRequestSort}
          setPageLimit={(value: number) => setPageLimit(value)}
          setPage={(value: number) => setPage(value)}
        />
      </section>
    </div>
  );
};

export default RoomMeetingDevice;
